import c from './app-block-flex.vue';

export default c;
